// CommentList.js
import React, { useState } from 'react';
import Header from '../Header';
import Inprogress from '../utils/Inprogress';


const CommentList = () => {

  return (
    <div className="comment-list">
        <Inprogress/>
    </div>
  );
};

export default CommentList;
